import React, { useContext } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Header from "./Header";
import HospitalAdmitsAndErVisitTable from "../Tables/WcchcDashboard/HospitalAdmitsAndErVisitTable";
import { WcchcPatientSummaryContext } from "../../Contexts/wcchcPatientSummaryContext";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    width: "100%",
    height: (props) => props.height,
    overflow: "hidden",
  },
  mainContainerOutline: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    width: "100%",
    height: "329px",
    border: "1px solid #FD0808",
    overflow: "hidden",
  },
}));

const HospitalAdmitsAndErVisit = ({ setHospitalAdmitsAndErVisits, attentive, setAttentive, showBorder }) => {
  const { state } = useContext(WcchcPatientSummaryContext);
  let height = state.tablesDataLength.hospitaladmits ? "329px" : "200px";
  const classes = useStyles({height});

  return (
    <Box
      className={`${attentive ? classes.mainContainerOutline : classes.mainContainer} ${showBorder ? "selected-border": ""}`}
      id="medications"
    >
      <Header
        title="Hospital Admits & ER Visits"
        onClick={setHospitalAdmitsAndErVisits}
        disable={state.isFetchingMedications}
      />
      <HospitalAdmitsAndErVisitTable setAttentive={setAttentive} />
    </Box>
  );
};

export default HospitalAdmitsAndErVisit;
